export const cartSelector = (state) => state.cart;
export const userSelector = (state) => state.user.user;
